import { render, staticRenderFns } from "./ContReportAssignment.vue?vue&type=template&id=53b2e838&lang=pug"
import script from "./ContReportAssignment.vue?vue&type=script&lang=js"
export * from "./ContReportAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b2e838')) {
      api.createRecord('53b2e838', component.options)
    } else {
      api.reload('53b2e838', component.options)
    }
    module.hot.accept("./ContReportAssignment.vue?vue&type=template&id=53b2e838&lang=pug", function () {
      api.rerender('53b2e838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/ContReportAssignment.vue"
export default component.exports